import styled from 'styled-components';

export const MonthOnMonthPageWrapper = styled.div`
  margin-top: 0.5rem;
`;
